export default {
  deliver_name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
  deliver_province: [
    { required: true, message: '请输入所在省', trigger: 'change' },
  ],
  deliver_city: [
    { required: true, message: '请输入所在市', trigger: 'change' },
  ],
  deliver_district: [
    { required: true, message: '请输入所在区', trigger: 'change' },
  ],
  deliver_address: [
    { required: true, message: '请输入详细地址', trigger: 'change' },
  ],
  deliver_phone: [
    {
      validator: function(rule, value, callback) {
        if (value === '') {
          this.message = '请输入电话号'
          callback(new Error())
          return false
        }
        if (!/^1\d{10}$/.test(value)) {
          this.message = '请输入正确的电话号格式'
          callback(new Error())
          return false
        }
        callback()
      },
      trigger: 'change',
      required: true,
    },
  ],
  email: [
    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['change'] },
  ],
}
